// extracted by mini-css-extract-plugin
export var avatarContainer = "_5o-1";
export var largeAvatarContainer = "_5o-2";
export var smallAvatarContainer = "_5o-0";